import React from "react"
import { Toggle, SelectField, MenuItem, TextField } from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { ITriggerDuration } from "../../models"
import * as utils from "../../helpers/utils"
import { red500 } from "material-ui/styles/colors"

interface IProps {
    triggerDuration: ITriggerDuration
    handleChange(triggerDuration: ITriggerDuration)
}
interface IState {
    enableTriggerQuestion: boolean
    firstValueType: ETriggerDurationValueType
    firstValue: number
    secondValueType: ETriggerDurationValueType
    secondValue: number
    error: string
}

enum ETriggerDurationValueType {
    None,
    greater_than,
    less_than
}

export default class QuestionPunchTriggerDuration extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const firstValueData = this.getFirstValueData(props.triggerDuration)
        const secondValueData = this.getSecondValueData(props.triggerDuration)
        this.state = {
            enableTriggerQuestion: props.triggerDuration ? true : false,
            firstValueType: firstValueData.type,
            firstValue: firstValueData.value,
            secondValueType: secondValueData.type,
            secondValue: secondValueData.value,
            error: null,
        }
        autobind(this)
    }

    getFirstValueData(triggerDuration: ITriggerDuration) {
        let returnVal = { type: ETriggerDurationValueType.None, value: 0 }
        if (triggerDuration) {
            if (triggerDuration.Greater > 0 && triggerDuration.Less > 0) {
                returnVal = { type: ETriggerDurationValueType.greater_than, value: triggerDuration.Greater }
            }
            else if (triggerDuration.Greater > 0) {
                returnVal = { type: ETriggerDurationValueType.greater_than, value: triggerDuration.Greater }
            }
            else if (triggerDuration.Less > 0) {
                returnVal = { type: ETriggerDurationValueType.less_than, value: triggerDuration.Less }
            }
        }
        return returnVal
    }

    getSecondValueData(triggerDuration: ITriggerDuration) {
        let returnVal = { type: ETriggerDurationValueType.None, value: 0 }
        if (triggerDuration) {
            if (triggerDuration.Greater > 0 && triggerDuration.Less > 0) {
                returnVal = { type: ETriggerDurationValueType.less_than, value: triggerDuration.Less }
            }
        }
        return returnVal
    }

    handleChange() {
        if (!this.checkValudate()) return
        const triggerDuration = this.getTriggerDuration()
        this.props.handleChange(triggerDuration)
    }

    checkValudate() {
        let isValid = true
        if (this.state.enableTriggerQuestion) {
            let greater: number = null
            let less: number = null
            if (this.state.firstValueType === this.state.secondValueType) {
                isValid = false
            }
            else {
                if (this.state.firstValueType !== ETriggerDurationValueType.None) {
                    if (this.state.firstValue > 0) {
                        if (this.state.firstValueType === ETriggerDurationValueType.greater_than) {
                            greater = this.state.firstValue
                        }
                        if (this.state.firstValueType === ETriggerDurationValueType.less_than) {
                            less = this.state.firstValue
                        }
                    }
                    else {
                        isValid = false
                    }
                }
                if (this.state.secondValueType !== ETriggerDurationValueType.None) {
                    if (this.state.secondValue > 0) {
                        if (this.state.secondValueType === ETriggerDurationValueType.greater_than) {
                            greater = this.state.secondValue
                        }
                        if (this.state.secondValueType === ETriggerDurationValueType.less_than) {
                            less = this.state.secondValue
                        }
                    }
                    else {
                        isValid = false
                    }
                }

                if (greater > 0 && less > 0 && greater >= less) {
                    isValid = false
                }
            }
        }
        this.setState({ error: isValid ? "" : strings.Invalid_timeframe })
        return isValid
    }

    getTriggerDuration() {
        let returnVal: ITriggerDuration = null
        if (this.state.enableTriggerQuestion) {
            let greater: number = null
            let less: number = null
            if (this.state.firstValueType === ETriggerDurationValueType.greater_than) {
                greater = this.state.firstValue
            }
            if (this.state.firstValueType === ETriggerDurationValueType.less_than) {
                less = this.state.firstValue
            }
            if (this.state.secondValueType === ETriggerDurationValueType.greater_than) {
                greater = this.state.secondValue
            }
            if (this.state.secondValueType === ETriggerDurationValueType.less_than) {
                less = this.state.secondValue
            }
            returnVal = { Greater: greater, Less: less }
        }
        return returnVal
    }

    render() {
        return (
            <div style={{ marginTop: 20, height: 85 }}>
                <Toggle
                    label={strings.Time_duration_to_trigger_question}
                    labelStyle={{ fontSize: 16 }}
                    style={{ width: 300 }}
                    toggled={this.state.enableTriggerQuestion}
                    onToggle={(e, value) => this.setState({ enableTriggerQuestion: value }, () => this.handleChange())}
                />
                {this.state.enableTriggerQuestion &&
                    <div>
                        <div style={{ marginTop: -15, display: "flex", alignItems: "baseline" }}>
                            <div style={{ marginTop: 45 }}>
                                {strings.This_question_will_only_be_asked_after_a_duration_of}
                            </div>
                            <SelectField
                                autoWidth
                                style={{ width: 150, marginLeft: 15 }}
                                value={this.state.firstValueType}
                                onChange={(e, key, firstValueType) => this.setState({ firstValueType, firstValue: firstValueType === ETriggerDurationValueType.None ? null : this.state.firstValue }, () => this.handleChange())}
                            >
                                <MenuItem value={ETriggerDurationValueType.None} primaryText={strings.None} />
                                <MenuItem value={ETriggerDurationValueType.greater_than} primaryText={strings.greater_than} />
                                <MenuItem value={ETriggerDurationValueType.less_than} primaryText={strings.less_than} />
                            </SelectField>
                            {this.state.firstValueType !== ETriggerDurationValueType.None &&
                                <TextField
                                    style={{ width: 50, marginLeft: 15 }}
                                    floatingLabelText={strings.minutes}
                                    value={this.state.firstValue}
                                    onChange={(e, value) => utils.validateInteger(value) && this.setState({ firstValue: Number(value) }, () => this.handleChange())}
                                />
                            }
                            <div style={{ marginLeft: 15 }}>{strings.and}</div>
                            <SelectField
                                autoWidth
                                style={{ width: 150, marginLeft: 15 }}
                                value={this.state.secondValueType}
                                onChange={(e, key, secondValueType) => this.setState({ secondValueType, secondValue: secondValueType === ETriggerDurationValueType.None ? null : this.state.secondValue }, () => this.handleChange())}
                            >
                                <MenuItem value={ETriggerDurationValueType.None} primaryText={strings.None} />
                                <MenuItem value={ETriggerDurationValueType.greater_than} primaryText={strings.greater_than} />
                                <MenuItem value={ETriggerDurationValueType.less_than} primaryText={strings.less_than} />
                            </SelectField>
                            {this.state.secondValueType !== ETriggerDurationValueType.None &&
                                <TextField
                                    style={{ width: 50, marginLeft: 15 }}
                                    floatingLabelText={strings.minutes}
                                    value={this.state.secondValue}
                                    onChange={(e, value) => utils.validateInteger(value) && this.setState({ secondValue: Number(value) }, () => this.handleChange())}
                                />
                            }
                            <div style={{ marginLeft: 15 }}>{strings.after_punch_in}</div>
                        </div>
                        <div style={{ fontSize: 12, color: red500, marginTop: -47 }}>{this.state.error}</div>
                    </div>
                }
            </div>
        )
    }
}